import { useClassNames } from '@magnetic/hooks';
import React, { forwardRef, useMemo } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const withMagneticIcon = /* @__PURE__ */ __name((Icon) => forwardRef(({ className, ...props }, ref) => {
  const classNames = useClassNames("mds-icon-phosphor", className);
  const filteredProps = useMemo(
    () => Object.fromEntries(
      Object.entries(props).filter(
        ([, value]) => typeof value !== "undefined"
      )
    ),
    [props]
  );
  return /* @__PURE__ */ React.createElement(Icon, { ...filteredProps, className: classNames, ref });
}), "withMagneticIcon");

export { withMagneticIcon };
//# sourceMappingURL=withMagneticIcon.js.map
